export const spreadsheetsEN = {
  "There no individual spreadsheets to display": "There no individual spreadsheets to display",
  "New Spreadsheet": "New Spreadsheet",
  "Actions": "Actions",
  "Format Name": "Format Name",
  "Description": "Description",
  "Folder": "Folder",
  "Modified By": "Modified By",
  "Date Modified": "Date Modified",
  "Created By": "Created By",
  "Date Created": "Date Created",
  "Run Spreadsheet": "Run Spreadsheet",
  "Edit Spreadsheet": "Edit Spreadsheet",
  "Delete Spreadsheet": "Delete Spreadsheet",
  "Are you sure you want to delete the selected format?": "Are you sure you want to delete the selected format?",
  'Delete Format': 'Delete Format',
  'Cancel': 'Cancel',
  'Query (Optional)': 'Query (Optional)',
  'Sort (Optional)': 'Sort (Optional)',
  'Columns': 'Columns',
  'Are you sure you wish to remove all fields?': 'Are you sure you wish to remove all fields?',
  'Are you sure you wish to remove all sort fields?': 'Are you sure you wish to remove all sort fields?',
  'Direction': 'Direction',
  'Ascending': 'Ascending',
  'Descending': 'Descending',
  'Failed to save formats': 'Failed to save formats',
  'This field is required': 'This field is required',
  'Missing required data for upload. Please ensure all required fields are available.': 'Missing required data for upload. Please ensure all required fields are available.',
  'Information Message': 'Information Message',
  'Number field accepts numeric values only, please re-try.': 'Number field accepts numeric values only, please re-try.',
  'Invalid number': 'Invalid number',
  'Upload Error': 'Upload Error',
  'Confirmation message': 'Confirmation message',
  'Upload Success': 'Upload Success',
  'Overwrite failed': 'Overwrite failed',
  'Overwrite': 'Overwrite',
  'File upload failed. Please try again.': 'File upload failed. Please try again.',
  'File type not allowed: {fileName}': 'File type not allowed: {fileName}',
  'File "{fileName}" already exists. Overwrite?': 'File "{fileName}" already exists. Overwrite?',
  'File "{fileName}" uploaded successfully.': 'File "{fileName}" uploaded successfully.',
  'Browse to {value}': 'Browse to {value}',
  'Open': 'Open',
  'Download': 'Download',
  'Click to view full image for {value}': 'Click to view full image for {value}',
  'Upload Image': 'Upload Image',
  'Upload Document': 'Upload Document',
  'Yes (Y)': 'Yes (Y)',
  'No (N)': 'No (N)',
};